    // Signature inflation/deflation
    var inflateToJsonSignature = function (deflatedSig) {
        var intArray = [];
        if (deflatedSig.indexOf('[') == 0 && deflatedSig.lastIndexOf(']') == deflatedSig.length-1)
        	intArray = JSON.parse(deflatedSig);
        else {
            for (var i = 0; i < deflatedSig.length; i++) {
                intArray.push((deflatedSig[i].charCodeAt()).toString(16));
            }
        }

        var sigString = "[";
        for (var j = 0; j < intArray.length; j = j + 4) {
            sigString += (
                '{"lx":' + intArray[j] +
                ',"ly":' + intArray[j + 1] +
                ',"mx":' + intArray[j + 2] +
                ',"my":' + intArray[j + 3] + '},');
        }
        return sigString.substring(0, (sigString.length - 1)) + "]";
    };

    var deflateFromJsonSignature = function (jsonSig) {
        var replacedSig = jsonSig.substring(2, jsonSig.length - 2).replace(/"lx":/g, "")
            .replace(/"ly":/g, "").replace(/"mx":/g, "").replace(/"my":/g, "")
            .replace(/},{/g, ",");
        var compressString = "[";
        var components = replacedSig.split(',');
        compressString += components.join(',');
        compressString += "]";
        return compressString;
    };
    
    var scaleJsonSignature = function(jsonSig, fromWidth, fromHeight, toWidth, toHeight) {
        console.log('scale signature from ' + fromWidth + 'x' + fromHeight + ' to ' + toWidth + 'x' + toHeight);
        try {
            var points = JSON.parse(jsonSig);
            for (var i = 0; i < points.length; i++) {
                points[i].lx = Math.round(points[i].lx*toWidth/fromWidth);
                points[i].ly = Math.round(points[i].ly*toHeight/fromHeight);
                points[i].mx = Math.round(points[i].mx*toWidth/fromWidth);
                points[i].my = Math.round(points[i].my*toHeight/fromHeight);
            }
            return points;
        } catch (e) {
            console.error('Failed to parse signature data');
            // return a cross
            return [ { lx: 0, ly: 0, mx: toWidth, my: toHeight }, { lx: 0, ly: toHeight, mx: toWidth, my: 0 } ];
        }
    };
    